<template>
  <v-dialog v-model="showModal" width="520px">
    <v-card v-if="factoring" elevation="12">
      <v-icon style="position:absolute; top: 0; right: 0; margin-right: 15px;" @click="showModal = false">
        mdi-close
      </v-icon><br>
      <v-card-title class="justify-center" style="font-size: 19px;">
        <span><b>{{ $t('FactoringInformation.Factoring information') }}</b></span>
      </v-card-title>
      <v-card-text align="center">
        <span v-html="getStatusText()" />
      </v-card-text>
      <v-card-text v-if="(!statusCreated || iAmTheMiddle) && (!statusAccepted || iHaveAccepted)">
        <v-card color="background">
          <v-card-title class="justify-center" style="font-size: 17px">
            <b>{{ $t('Factoring information:') }}</b>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col>
                <v-card align="center" raised height="130px">
                  <v-card-title class="justify-center" style="font-size: 11px">
                    <b>{{ $t('Outstanding Amount') }}</b>
                  </v-card-title>
                  <v-card-text>
                    <p style="color: #43E1B2; font-size: 20px">
                      {{ outStandingAmount.toFixed(2) }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card align="center" raised height="130px">
                  <v-card-title class="justify-center" style="font-size: 11px;">
                    <b>{{ $t('Compensation') }}</b>
                  </v-card-title>
                  <v-card-text>
                    <p style="color: #43E1B2; font-size:20px">
                      {{ compensationAmount.toFixed(2) }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <ShowInvoiceInformation :title="$t('Payer invoice:')" :invoice="factoring.invoice_payer" />
        <ShowInvoiceInformation :title="$t('Receiver invoice:')" :invoice="factoring.invoice_receiver" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import {Factoring} from "../models/factoring";
import ShowInvoiceInformation from "./ShowInvoiceInformation";

export default {
    name: "RemindOptions",
    components: {ShowInvoiceInformation},
    data () {
        return {
            showModal: false,
            factoring: null,
            outStandingAmount: 0,
            compensationAmount: 0,
            currentInvoice: null,
            factoringModel: null
        };
    },
    computed: {
        anyInvoice () {
            return this.invoices.length > 0;
        },
        statusCreated () {
            if (this.currentInvoice && this.currentInvoice.relatedFactoring) {
                return this.currentInvoice.relatedFactoring.status === Constants.FACTORING.STATUS_CREATED;
            }
            return false;
        },
        statusRejected () {
            if (this.currentInvoice && this.currentInvoice.relatedFactoring) {
                return this.currentInvoice.relatedFactoring.status === Constants.FACTORING.STATUS_DISCARDED || this.currentInvoice.relatedFactoring.status === Constants.FACTORING.STATUS_REJECTED;
            }
            return false;
        },
        statusAccepted () {
            if (this.currentInvoice && this.currentInvoice.relatedFactoring) {
                return this.currentInvoice.relatedFactoring.status === Constants.FACTORING.STATUS_ACCEPTED;
            }
            return false;
        },
        statusPayed () {
            if (this.currentInvoice && this.currentInvoice.relatedFactoring) {
                return this.currentInvoice.relatedFactoring.status === Constants.FACTORING.STATUS_PAYED;
            }
            return false;
        },
        iAmTheMiddle () {
            return this.factoringModel && this.factoringModel.iAmTheMiddle();
        },
        iHaveAccepted () {
            return this.factoringModel && this.factoringModel.iHaveAccepted();
        },
    },
    methods: {
        show (currentInvoice, factoring) {
            this.currentInvoice = currentInvoice;
            this.$root.$emit('start-loading');
            ApiRepository.getFactoringById(factoring._id)
                .then((res) => {
                    this.factoring = res.data.factoring;
                    this.factoringModel = new Factoring(this.currentInvoice.relatedFactoring, this.$user, this.$parameters);
                    this.calculateAmount();
                    this.showModal = true;
                })
                .catch((err) => {
                    console.log(err);
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.Something went wrong'), color: 'error'});
                })
                .finally(() => {
                    this.$root.$emit('stop-loading');
                });
        },
        calculateAmount () {
            if (this.factoring.invoice_payer.amount < this.factoring.invoice_receiver.amount) { // Cas 1
                this.outStandingAmount = this.factoring.amount;
                this.compensationAmount = this.factoring.compensation;
            } else { // cas 3
                this.outStandingAmount = this.factoring.compensation - this.factoring.invoice_receiver.amount;
                if (this.outStandingAmount > 0) {
                    this.compensationAmount = this.factoring.compensation - this.outStandingAmount;
                } else {
                    this.outStandingAmount = (this.factoring.invoice_receiver.amount - this.factoring.compensation) * (1 + 0.05).toFixed(2);
                    this.compensationAmount = this.factoring.compensation;
                }
            }
        },
        getStatusText () {
            if ((this.statusCreated && !this.iAmTheMiddle) || (this.statusAccepted && !this.iHaveAccepted)) {
                return this.$t('You have to accept or reject the factoring.');
            } else {
                switch (this.factoring.status) {
                case Constants.FACTORING.STATUS_CREATED:
                    return this.$t('Waiting for your partner') + " <b>" + this.factoring.receiver.cif + "</b> " + this.$t('to accept or deny this bypay.');
                case Constants.FACTORING.STATUS_REJECTED:
                    return this.$t('Your partner') + " <b>" + this.factoring.receiver.cif + "</b> " + this.$t('has denied this bypay.');
                case Constants.FACTORING.STATUS_ACCEPTED:
                    return this.$t('Waiting for your partner') + " <b>" + this.factoring.payer.cif + "</b> " + this.$t('to accept or deny this bypay.');
                case Constants.FACTORING.STATUS_UNPAYED:
                    return this.$t('Your partner') + " <b>" + this.factoring.payer.cif + "</b> " + this.$t('has denied this bypay.');
                case Constants.FACTORING.STATUS_PAYED:
                    return this.$t('This bypay has been approved by') + " <b> " + this.$t('all') + " </b> " + this.$t('partners!');
                }
                return "";
            }
        }
    }
};
</script>

<style scoped>

</style>
